import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import SBProFooter from '@structural/footer.vue';
let SBProLayoutDefault = class SBProLayoutDefault extends Vue {
};
__decorate([
    Prop({ default: 'bg-light footer-light' })
], SBProLayoutDefault.prototype, "footerClasses", void 0);
SBProLayoutDefault = __decorate([
    Component({
        components: {
            'sbpro-footer': SBProFooter,
        },
    })
], SBProLayoutDefault);
export default SBProLayoutDefault;
